import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-winlose-detail-sports',
  templateUrl: './winlose-detail-sports.component.html',
  styleUrls: ['./winlose-detail-sports.component.scss'],
})
export class WinloseDetailSportsComponent implements OnInit, OnChanges {
  @Input() DetailSports: any;
  constructor() {}

  ngOnInit() {}

  ngOnChanges() {}
}
